import React, { useRef, useCallback, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import { db } from "../../../firebase";
import { doc, getDoc, collection, query, where, getDocs, updateDoc } from "firebase/firestore";

import SEO from '../../SEO';
import Loading from "../../Loading";
import MyPageMenu from "./MyPageMenu";
import Popup from "../../mobile/Popup";
import CheckBoxSelector from "../CheckBoxSelector";
import MusicianGalleryPopup from './MusicianGalleryPopupNew';
import MusicardCTA from '../MusicardCTA';

import { useUser } from '../../../store/UserProvider';
import { saveUserLog, DeleteMusicard } from '../LogandUtils'; // 경로에 맞게 수정

import styleClasses from '../css/mobile/MyPage.module.scss';

import LazyLoad from "react-lazyload";
import { LazyLoadImage } from "react-lazy-load-image-component";

import "react-lazy-load-image-component/src/effects/blur.css";

function MusicardPage() {
  const { user, userLoading } = useUser();
    
  const navigate     = useNavigate();
  const isSubmitting = useRef(false);

  const [openMenu, setOpenMenu]               = useState(false);
  const [userID, setUserID]                   = useState(null);
  const [musicards, setMusicards]             = useState([]);
  const [isLoading, setIsLoading]             = useState(true);
  const [ownedCount, setOwnedCount]           = useState(0);
  const [cardSlot, setCardSlot]               = useState(0);
  const [openPopup, setOpenPopup]             = useState(false);
  const [openCTAPopup, setOpenCTAPopup] = useState(false);
  const [buttonLoading, setButtonLoading]     = useState(false);
  const [popupTitle, setPopupTitle]           = useState('');
  const [popupFunction, setPopupFunction]     = useState('');
  const [popupButtonText, setPopupButtonText] = useState('');

  const [editingCardId, setEditingCardId] = useState(null);
  const [editingTitle, setEditingTitle] = useState("");
  // 카드의 장르 또는 포지션 편집 팝업 상태 관리
  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [editField, setEditField] = useState(""); // "genres" 또는 "positions"
  const [editCard, setEditCard] = useState(null);
  const [editFieldValue, setEditFieldValue] = useState([]); // 임시 선택 값
  // 추가: 메타데이터 상태 (장르, 포지션)
  const [genreOptions, setGenreOptions] = useState([]);
  const [positionOptions, setPositionOptions] = useState([]);
  const [openGalleryPopup, setOpenGalleryPopup] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [selectedImageType, setSelectedImageType] = useState("");

  const [music, setMusic] = useState('released');
  const [artistType, setArtistType] = useState('solo');

  // 🔹 메뉴 열기
  const toogleMenu = useCallback(
    (event) => {
      const menuIcon = event.target.closest(`.${styleClasses.menuIcon}`);
      const menuBox = event.target.closest(`.${styleClasses.leftContent}`);

      if (openMenu) {
        if (!menuBox) setOpenMenu(false);
      } else {
        if (menuIcon || menuBox) setOpenMenu(true);
      }
    },
    [openMenu, setOpenMenu]
  );

  // 🔹 메뉴 열기 (스크린 전체 이벤트 추가)
  useEffect(() => {
    document.body.addEventListener("click", toogleMenu);

    return () => {
      document.body.removeEventListener("click", toogleMenu);
    };
  }, [toogleMenu]);

  // 메타데이터 (장르/포지션) 불러오기
  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const genresRef = doc(db, "metadata", "genres");
        const positionsRef = doc(db, "metadata", "positions");

        const genresSnap = await getDoc(genresRef);
        const positionsSnap = await getDoc(positionsRef);

        if (genresSnap.exists()) setGenreOptions(genresSnap.data().list);
        if (positionsSnap.exists()) setPositionOptions(positionsSnap.data().list);
      } catch (error) {
        console.error("메타데이터 불러오기 실패:", error);
      }
    };
    fetchMetadata();
  }, []);
  
  // 상단 추가 버튼을 위해 Musicard 추가 페이지로 이동하는 링크를 추가합니다.
  // 예: /my-page/musicard/add

  const fetchMusicards = useCallback(async () => {
    if (!userID) return; // userID가 없으면 실행하지 않음

    try {
      const userRef = doc(db, "users", userID);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) return;

      const userData = userSnap.data();
      // musicard 필드: 객체의 키 개수가 보유한 뮤지카드 수
      const owned = userData.musicard ? Object.keys(userData.musicard).length : 0;
      setOwnedCount(owned);
      // cardslot 필드: 보유 가능한 뮤지카드 슬롯 수
      setCardSlot(userData.cardslot || 1);
      
      if (!userData.musicard) {
        setIsLoading(false);
        return;
      }

      const musicardIds = Object.values(userData.musicard);
      if (musicardIds.length === 0) {
        setIsLoading(false);
        return;
      }

      const musiciansCollection = collection(db, "musicians");
      let fetchedCards = [];

      // 10개씩 배치로 가져오기
      for (let i = 0; i < musicardIds.length; i += 10) {
        const batchIds = musicardIds.slice(i, i + 10);
        const musiciansQuery = query(musiciansCollection, where("id", "in", batchIds));
        const musiciansSnap = await getDocs(musiciansQuery);

        const validCards = musiciansSnap.docs
          .map((doc) => ({
            id: doc.id,
            act: doc.data().act,
            title: doc.data().name,
            genres: doc.data().genres || [],
            positions: doc.data().positions || [],
            image: doc.data().profileImage || "",
            ownerId: doc.data().ownerId || "",
          }))
          .filter((card) => card.ownerId === userID);

        fetchedCards = [...fetchedCards, ...validCards];
      }

      setMusicards(fetchedCards);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("뮤지카드 데이터 가져오기 실패:", error);
    }
  }, [userID]);

  // 🔹 뮤지카드 조회 전 로그인 세션 확인
  useEffect(() => {
    if (userLoading) return;

    if (user?.userID) {
      setUserID(user.userID);
      setIsLoading(true);
      fetchMusicards();
    } else {
      navigate('/login');
    }
  }, [fetchMusicards, navigate, user?.userID, userLoading]);

  // 뮤지카드 클릭 시 상세 페이지 이동
  const handleMusicardClick = (musicianID) => {
    navigate(`/my-page/musicard/${musicianID}`);
  };

  // act 토글 업데이트 함수
  const handleToggleAct = async (card) => {
    try {
      // musicians 문서 업데이트: act 값을 반전
      await updateDoc(doc(db, "musicians", card.id), {
        act: !card.act,
      });

      await saveUserLog('musicard_logs', card.id, 'update', `musicians/${card.id}`, 'MusicardPage');

      // 로컬 상태 업데이트: musicards 배열의 해당 카드 act 값을 반전시킴
      setMusicards((prevCards) =>
        prevCards.map((c) =>
          c.id === card.id ? { ...c, act: !c.act } : c
        )
      );
    } catch (error) {
      console.error("act 토글 업데이트 오류:", error);
      alert("act 토글 업데이트 중 오류가 발생했습니다.");
    }
  };

  // 🔹 뮤지카드 삭제 팝업
  const openDeleteMusicard = (card) => {
    if (card.act) {
      // act가 true이면 활성화된 상태이므로 삭제하지 않음
      setOpenPopup(true);
      setPopupTitle('해당 뮤지카드는 활성화되어 있습니다. <br/>먼저 비활성화한 후 삭제하세요.');
      setPopupButtonText('');
      setPopupFunction('');
    } else {
      setOpenPopup(true);
      setPopupTitle('해당 뮤지카드를 삭제하시겠습니까?');
      setPopupButtonText('삭제');
      setPopupFunction(() => () => handleDeleteMusicard(card) );
    }
  }

  // 🔹 뮤지카드 삭제 함수
  const handleDeleteMusicard = async (card) => {
    try {
      if (isSubmitting.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting.current = true;      // 버튼 비활성화
      setButtonLoading(true);           // 버튼 로딩 표시
  
      // LogandUtils.jsx에 분리한 DeleteMusicard 함수 호출
      await DeleteMusicard(card);
  
      isSubmitting.current = false;   // 버튼 활성화
      setButtonLoading(false);        // 버튼 로딩 숨김
  
      setOpenPopup(true);
      setPopupTitle('뮤지카드가 삭제되었습니다.');
      setPopupButtonText('');
      setPopupFunction('');
  
      // 삭제 후 뮤지카드 목록 새로고침
      fetchMusicards();
    } catch (error) {
      isSubmitting.current = false;   // 버튼 활성화
      setButtonLoading(false);        // 버튼 로딩 숨김
  
      setOpenPopup(true);
      setPopupTitle('뮤지카드 삭제 중 오류가 발생했습니다.');
      setPopupButtonText("뮤지카드 삭제 오류:", error);
      setPopupFunction('');
    }
  };

  // 제목 수정 시작 핸들러: 해당 카드의 제목을 편집 모드로 변경
  const handleTitleEdit = (card) => {
    setEditingCardId(card.id);
    setEditingTitle(card.title);
  };

  // 제목 저장 핸들러: Firestore와 로컬 상태 업데이트
  const handleSaveTitle = async (cardId) => {
    try {
      // Firestore 업데이트 (musicians 컬렉션의 name 필드 업데이트)
      await updateDoc(doc(db, "musicians", cardId), { name: editingTitle });
      
      // 로컬 상태 업데이트
      setMusicards((prevCards) =>
        prevCards.map((card) =>
          card.id === cardId ? { ...card, title: editingTitle } : card
        )
      );
      // 편집 상태 초기화
      setEditingCardId(null);
      setEditingTitle("");
    } catch (error) {
      console.error("타이틀 업데이트 오류:", error);
      alert("제목 업데이트 중 오류가 발생했습니다.");
    }
  };

  // 팝업을 열 때 호출하는 핸들러
  const handleEditField = (card, field) => {
    setEditCard(card);
    setEditField(field);
    setEditFieldValue(card[field] || []); // 해당 카드의 기존 값을 초기값으로 설정
    setEditPopupOpen(true);
  };

  // 수정된 내용을 저장하는 핸들러 (Firestore와 로컬 상태 업데이트)
  const handleSaveEditField = async () => {
    if (!editCard || !editField) return;
    try {
      // Firestore 업데이트: musicians 컬렉션의 해당 카드 문서를 업데이트
      await updateDoc(doc(db, "musicians", editCard.id), {
        [editField]: editFieldValue,
      });
      // 로컬 상태 업데이트
      setMusicards((prevCards) =>
        prevCards.map((card) =>
          card.id === editCard.id ? { ...card, [editField]: editFieldValue } : card
        )
      );
      // 편집 상태 초기화
      setEditPopupOpen(false);
      setEditField("");
      setEditCard(null);
      setEditFieldValue([]);
    } catch (error) {
      console.error("필드 업데이트 오류:", error);
      alert("업데이트 중 오류가 발생했습니다.");
    }
  };

  const openMusicianGallery = (cardId) => {
    setSelectedCardId(cardId);
    setSelectedImageType("profile");
    setOpenGalleryPopup(true);
  };

  const handleSelectImage = async (imageUrl) => {
    if (!selectedCardId) return;
    try {
      // Firestore 업데이트: musicians 컬렉션의 해당 카드의 profileImage 필드 업데이트
      await updateDoc(doc(db, "musicians", selectedCardId), { profileImage: imageUrl });
      
      // 로컬 상태 업데이트: 해당 카드의 image 필드를 변경
      setMusicards((prevCards) =>
        prevCards.map((card) =>
          card.id === selectedCardId ? { ...card, image: imageUrl } : card
        )
      );
    } catch (error) {
      console.error("프로필 이미지 업데이트 오류:", error);
      alert("이미지 업데이트 중 오류가 발생했습니다.");
    }
    setOpenGalleryPopup(false);
    setSelectedCardId(null);
  };  

  const openMusicardCTAPopup = () => {
    setPopupTitle('뮤지카드 생성');
    setPopupButtonText('시작하기');
    setOpenCTAPopup(true);
    //GA 세팅
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "mzc_generate_start"
    });
  };
  
  
  return (
    <>
      <SEO title='뮤지카드 목록' />
      <div className={ styleClasses.myPageMobile }>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.title }>
            {/* 페이지 제목에 보유한 뮤지카드 갯수 / 보유 가능한 슬롯 수 출력 */}
            <h1>My MusiCards <span className={ styleClasses.purpleColor }>{ownedCount}</span> / {cardSlot}</h1>
            <button className={ styleClasses.menuIcon }>
              <div className="commonIcon mobile">
                <i className={`${ openMenu ? 'upWhite' : 'downWhite' } w24`}></i>
              </div>
            </button>
            <div className={`commonIcon mobile toolTip ${ styleClasses.titleToolTip }`}>
              <i className="questionBlack w20"></i>
              <div className="toolTipText bottom">
                <p>뮤지카드 현재 사용중인 슬롯 / 소유 슬롯<br />비공개 / 공개 : 뮤지카드 활성화 (목록에 추가 & 검색엔진 노출)</p>
              </div>
            </div>
          </div>
          <div className={styleClasses.editContent}>
            <div className={`${ styleClasses.leftContent } ${ openMenu ? styleClasses.open : '' }`}>
              <MyPageMenu />
            </div>
            <div className={styleClasses.rightContent}>
              <div className={styleClasses.content}>
                <div className={styleClasses.myArchive}>
                  <div className={styleClasses.topButtons}>
                    <div className={`commonIcon toolTip mobile ${ styleClasses.topButtonToolTip }`}>
                      <i className="questionBlack w20"></i>
                      <div className="toolTipText bottom">
                        <p>여유 슬롯에 뮤지카드를 추가해보세요!</p>
                      </div>
                    </div>
                      {/* 상단에 추가 버튼 추가 */}
                      <div className="commonButton fullWidth">
                      {
                        ownedCount >= cardSlot
                        ?
                        (
                          <button
                          className="black"
                          onClick={() => {
                            setOpenPopup(true);
                            setPopupTitle('여유 슬롯이 없어 뮤지카드를 만들 수 없습니다. <br/>기존 뮤지카드를 삭제하고 다시 시도해주세요.');
                            setPopupButtonText('');
                            setPopupFunction('');
                          }}
                          >
                          추가
                          </button>
                        )
                        :
                        (
                          //<Link to="/my-page/musicard/add" className="black">추가</Link>
                          <button className="black" onClick={openMusicardCTAPopup}>추가</button>
                        )
                      }
                      </div>
                  </div>
                  <div className={styleClasses.musicianList}>
                  {
                    isLoading
                    ?
                    (
                      <Loading />
                    )
                    :
                    musicards.length > 0
                    ?
                    (
                      musicards.map((card, index) => (
                      <div key={index} className={styleClasses.card} style={{ position: 'relative' }}>
                        {/* act 토글 버튼 - 왼쪽 상단 */}
                        <button className={`${ styleClasses.onOffButton } ${ card.act ? styleClasses.on : styleClasses.off }`} onClick={(e) => { e.stopPropagation(); handleToggleAct(card); }}>
                          { card.act ? "공개" : "비공개" }
                        </button>
                        {/* 삭제 버튼 (X 아이콘) - 우측 상단 */}
                        <button className={ styleClasses.deleteButton } onClick={(e) => { e.stopPropagation(); openDeleteMusicard(card); }}>
                          <div className="commonIcon mobile">
                            <i className="trashWhite w24"></i>
                          </div>
                        </button>
                        <div className={styleClasses.cardWrap } /*onClick={() => handleMusicardClick(card.id)}*/>
                          {
                            card.image
                            ?
                            (
                              <LazyLoad width="100%" height="100%" offset={480}>
                                <LazyLoadImage
                                    src={card.image}
                                    alt={card.title}
                                    className={styleClasses.cardImage}
                                    effect="blur"
                                    width="100%"
                                    height="100%"
                                    onError={(e) => { e.target.onerror = null; e.target.src = '/assets/images/image_error.svg'; }}
                                    onClick={() => openMusicianGallery(card.id)}
                                />
                              </LazyLoad>
                            )
                            :
                            (
                              <div className={styleClasses.placeholder} onClick={() => openMusicianGallery(card.id)}>
                                No Image
                              </div>
                            )
                          }
                          <div className={styleClasses.cardContent}>
                            {editingCardId === card.id ? (
                              <div>
                                <input
                                  type="text"
                                  value={editingTitle}
                                  onChange={(e) => setEditingTitle(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      handleSaveTitle(card.id);
                                    }
                                  }}
                                  onBlur={() => handleSaveTitle(card.id)}
                                  autoFocus
                                  className={styleClasses.cardTitleEditInput}
                                />
                              </div>
                            ) : (
                              <div className={ styleClasses.eachDescription }>
                                <h3 className={styleClasses.cardTitle}>
                                {card.title ? card.title : "이름 없음"}
                                </h3>
                                <button
                                  onClick={() => handleTitleEdit(card)}
                                >
                                <div className={`commonIcon mobile ${ styleClasses.innerIcon }`}>
                                  <i className="pencilBlack w16"></i>
                                </div>
                                </button>
                              </div>
                            )}
                            <div className={ styleClasses.eachDescription }>
                              <p className={styleClasses.genres}>
                                {card.genres && card.genres.length > 0 ? card.genres.join(", ") : "장르 없음"}
                              </p>
                              <button
                                onClick={() => handleEditField(card, 'genres')}
                              >
                                <div className={`commonIcon mobile ${styleClasses.innerIcon}`}>
                                  <i className="pencilBlack w16"></i>
                                </div>
                              </button>
                            </div>
                            <div className={ styleClasses.eachDescription }>
                              <p className={styleClasses.genres}>
                                {card.positions && card.positions.length > 0 ? card.positions.join(", ") : "포지션 없음"}
                              </p>
                              <button
                                onClick={() => handleEditField(card, 'positions')}
                              >
                                <div className={`commonIcon mobile ${styleClasses.innerIcon}`}>
                                  <i className="pencilBlack w16"></i>
                                </div>
                              </button>
                            </div>
                          </div>
                          <div className={styleClasses.cardButtons}>
                            <div className="commonButton fullWidth">
                              <button
                                className="black"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(`/musicard/${card.id}`, '_blank');
                                }}
                              >
                                바로가기
                              </button>
                              <button
                                //className="black"
                                onClick={() => handleMusicardClick(card.id)}
                              >
                                디테일 수정
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                    )
                    :
                    (
                    <p className={ styleClasses.noMusicard }>보유한 뮤지카드가 없습니다.</p>
                    )
                  }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } text='' buttonText={ popupButtonText } buttonFunction={ popupFunction } buttonLoading={ buttonLoading } />
      {editPopupOpen && (
        <Popup
          open={editPopupOpen}
          setOpenPopup={setEditPopupOpen}
          title={editField === "genres" ? "장르 편집" : "포지션 편집"}
          buttonText="저장"
          buttonFunction={handleSaveEditField}
          buttonLoading={false}
          contentClassName={"commonForm"} // 여기서 원하는 클래스를 전달
        >
          <div className="commonForm">
            <CheckBoxSelector
              label=""
              options={editField === "genres" ? genreOptions : positionOptions}
              selectedItems={editFieldValue}
              setSelectedItems={setEditFieldValue}
              styleClasses={styleClasses}
            />
          </div>
        </Popup>
      )}
      <MusicianGalleryPopup
        uid={ userID }
        open={ openGalleryPopup }
        setOpenPopup={ setOpenGalleryPopup }
        imageIndex={ 5 }
        buttonFunction={ handleSelectImage }  // 유효한 함수로 변경
        onSelectImage={ handleSelectImage }    // 선택된 이미지 URL을 처리하는 콜백
      />
      <Popup
        open={openCTAPopup}
        setOpenPopup={setOpenCTAPopup}
        title={popupTitle}
        buttonText={popupButtonText}
        buttonFunction={() =>
          navigate(
            `/my-page/musicard/create?music=${music}&type=${artistType}`
          )
        }
      >
        {/* 여기서 Live React 컴포넌트를 렌더 */}
        <MusicardCTA
          music={music}
          setMusic={setMusic}
          artistType={artistType}
          setArtistType={setArtistType}
        />
      </Popup>
    </>
  );
}

export default MusicardPage;